export enum CompanyRoleTypes {
  CLIENT = 'client',
  VENDOR = 'vendor'
}
